import React, { useState, useRef, useMemo, useEffect } from 'react';
import { SubNavBarComponent } from '../../components/layouts/layout1/subnavbar/SubNavBarComponent';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Icon, IconButton, InputLabel, MenuItem, Select, TextField, Chip, Input, ListItemText,
    Checkbox,
    ListItem,
    ListItemIcon,
    List,
    Snackbar
 } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CloseIcon from '@material-ui/icons/Close';
import './styleEventos.scss';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import customNoEventsOverlay from './customNoEventsOverlay';
import { addUsersToEvent, addUsersToEventAsync, createEventAsync, deleteEventAsync, deleteUserFromEvent, getEventsAsync, getUsersEvents, SearchUsers, SearchUsersSuccess, updateEventAsync } from '../../actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import { encryptData } from '../../utils/encrypt.service';
import { getUserById } from '../../actions/allUsersAction';
import { Alert } from '@material-ui/lab';
/*import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';*/

export const Eventos = () => {

    let emptyNewEvent = {
        id: 0,
        nameEvent: '',
        startDate: '',
        endDate: ''
    }

    const requestH = useSelector((state) => state.user.request);
    const gridRef = useRef();
    const [openNewEventDialog, setOpenNewEventDialog] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openProvDialog, setOpenProvDialog] = useState(false);
    const [newEvent, setNewEvent] = useState(emptyNewEvent);
    const [events, setEvents] = useState([]);
    const [validation, setValidation] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogButtonTxt, setDialogButtonTxt] = useState("");
    const [proveedorSelect, setProveedorSelect] = useState([]);
    const [provValidation, setProvValidation] = useState(false);
    const [eventId, setEventId] = useState(0);
    //const catUsuarios = useSelector(state => state.user.searchUsers)
    const [catUsersEvent, setCatUsersEvent] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [showAlert, setAlert] = React.useState(false);
    //const dispatch = useDispatch();

    useEffect(() => {
        getEvents();
    }, [])

    const getEvents = async () => {
        await getEventsAsync(requestH).then(resp => {
            if (resp.response && resp.response.length > 0)
            {
                setEvents(resp.response)
            }
            else {}
        })
    }

    const openDialogNewEvent = (data) => { 
        console.log("DATA: ", data)
        if (data == "nuevo")
        {
            setDialogTitle("CREAR EVENTO");
            setDialogButtonTxt("CREAR");
        }
        else
        {
            setDialogTitle("EDITAR EVENTO")
            setDialogButtonTxt("EDITAR");
            let eventInfo = { ...newEvent };
            eventInfo.id = data.cEveId;
            eventInfo.nameEvent = data.cEveName;
            let startDate = data.cEveStartDate.split('T')[0];
            let endDate = data.cEveEndDate.split('T')[0];
            eventInfo.startDate = startDate;
            eventInfo.endDate = endDate;
            /*eventInfo.startDate = data.startDate;
            eventInfo.endDate = data.endDate;*/
            setNewEvent(eventInfo);
            
        }
        setOpenNewEventDialog(true) 
    }
    const handleCloseNewEventDialog = () => { 
        setOpenNewEventDialog(false);
        setNewEvent(emptyNewEvent);
        setValidation(false);
    }

    const openDialogDeleteEvent = (data) => { 
        let eventInfo = { ...newEvent };
        eventInfo.id = data.cEveId;
        eventInfo.nameEvent = data.cEveName;
        setNewEvent(eventInfo);
        setOpenDeleteDialog(true)
     }
    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
    }

    const openDialogProv = (data) => {
        setEventId(data.cEveId)
        //getCatUser();
        getUsersOfEvent(data.cEveId);
        setOpenProvDialog(true) 
    }
    const handleCloseProvDialog = () => {
        setProvValidation(false);
        setProveedorSelect([]);
        setEventId(0);
        setOpenProvDialog(false);
        getEvents();
    }

    /*const getCatUser = () => {
        dispatch(SearchUsers(''))
    }*/

    const getUsersOfEvent = async (eveId) => {
        await getUsersEvents(eveId, requestH).then((res) => {
            if (res.sucess) {
                
                setCatUsersEvent(res.response);
                handlePreSelected(res.response);
            }
            else {
                console.log("ERROR: ", res.errorMessage)
            }
        })
    }

    /* Table */
    const pagination = true;
    const paginationPageSize = 10;
    const paginationPageSizeSelector = [5, 10, 15, 20, 25, 50, 100, 500, 1000];
    const rowHeight = 70;
    const showScroll = true;

    const tableColumns = [
        { field: 'cEveName', headerName: 'Evento', suppressMovable: true, sortable: true, wrapText: true, autoHeight: true },
        { field: 'dateEvent', headerName: 'Fecha del evento', suppressMovable: true, sortable: true, wrapText: true, autoHeight: true, type: 'date' },
        { field: 'usuarios', headerName: 'Usuarios', suppressMovable: true, sortable: false, wrapText: true, autoHeight: true, type: 'usuario'},
        { field: 'opciones', headerName: '', cellRenderer: getButtons, sortable: false, suppressMovable: true}
    ];

    const defaultColDef = useMemo(() => {
        return {
            wrapHeaderText: true,
            autoHeaderHeight: true,
            headerStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }),
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
            })
        };
    }, []);

    

    const autoSizeStrategy = {
        type: 'fitGridWidth',
        //type: 'fitCellContents',
        defaultMinWidth: 100,
    };

    const columnTypes = useMemo(() => {
        return {
            date: {
                valueFormatter: formatearFecha,
            },
            usuario: {
                valueFormatter: formatearUsuarios,
            }
        };
    }, []);

    function formatearFecha(data) {
        const startDate = data.data.cEveStartDate.split('T')[0];
        const endDate = data.data.cEveEndDate.split('T')[0];
        return startDate + " - " + endDate;
    }

    function formatearUsuarios(data) {
        /*if (data.data.usuarios && data.data.usuarios.length > 0)
        {
            let prov = [];
            data.data.usuarios.map((i) => {
                console.log("Usuarios: ", i.usuName)
                prov.push(i.usuName)
            })

            return prov
        }*/
       return data.data.cEveStatus > 0 ? "Con usuarios" : "Sin usuarios";
       /* if (data.data.cEveStatus > 0) {
        return "Con usuarios"
       }
        else { return "Sin usuarios" } */
    }

    function getButtons(data) {
        return (
            <div className='iconsContainer' >
                <IconButton aria-label='Editar' onClick={() => openDialogNewEvent(data.data)}>
                    <Icon style={{ color: '#37a7b9'}}>edit_icon</Icon>
                </IconButton>
                <IconButton aria-label='Proveedor' onClick={() => openDialogProv(data.data)}>
                    <Icon color='primary'>person_add_icon</Icon>
                </IconButton>
                <IconButton aria-label='Eliminar' onClick={() => openDialogDeleteEvent(data.data)}>
                    <Icon style={{ color: 'red'}}>delete_forever_icon</Icon>
                </IconButton>
            </div>
        )
    }

    const noRowsOverlayComponentParams = useMemo(() => {
        return {
            noRowsMessageFunc: () => 'Aún no hay eventos',
        };
    }, [])

    const onInputChange = (e, name) => {
        let evento = { ...newEvent }
        evento[e.target.id] = e.target.value;
        setNewEvent(evento)
    }

    const createEvent = async () => {
        if (newEvent.nameEvent && newEvent.startDate && newEvent.endDate)
        {
            setValidation(false);

            if (newEvent.id === 0) {
                //nuevo
                let body = {
                    "cEveName": newEvent.nameEvent,
                    "cEveStartDate": newEvent.startDate,
                    "cEveEndDate": newEvent.endDate
                }
    
                await createEventAsync(body, requestH).then((data) => {
                    if(data.sucess === true) {
                        handleCloseNewEventDialog();
                        getEvents();
                    }
                })
            } 
            else {
                //editar
                let body = {
                    "cEveId": newEvent.id,
                    "cEveName": newEvent.nameEvent,
                    "cEveStartDate": newEvent.startDate,
                    "cEveEndDate": newEvent.endDate
                }

                await updateEventAsync(body, requestH).then((data) => {
                    if (data.sucess === true) {
                        handleCloseNewEventDialog();
                        getEvents();
                    }
                })
            }
            
        }else {
            setValidation(true)
        }
    }
    
    const deleteEvent = async () =>
    {
        let body = {
            "cEveId": newEvent.id
        }

        await deleteEventAsync(body, requestH).then((resp) => {
            if (resp.sucess === true) {
                handleCloseDeleteDialog();
                getEvents();
            }
        })

    }

    /*---------------- */
    const handleSelectUser = async (userToAdd) => {
        console.log("USUARIO: ", userToAdd)
        const currentIndex = proveedorSelect.indexOf(userToAdd);
        const newChecked = [...proveedorSelect];

        if (currentIndex === -1) {
            await addUsersToEvent(eventId, userToAdd.id, requestH).then((res) => {
                if (res.sucess)
                {
                    newChecked.push(userToAdd);
                }
                else { console.log("ERROR") }
            })
        } else {
            await deleteUserFromEvent(parseInt(userToAdd.atqCode), requestH).then((res) => {
                if (res.sucess) {
                    newChecked.splice(currentIndex, 1);
                }
                else { console.log("ERROR AL REMOVER ") }
            })
        }

        if (newChecked && newChecked.length > 0) {
            const idsSelect = newChecked.map((i) => {
                return i.userID
            })

            setSelectedIds(idsSelect)
        }

        setProveedorSelect(newChecked);
        getUsersOfEvent(eventId);
    }

    const handlePreSelected = (userList) => {
        if (userList && userList.length > 0) {
            const usuariosSeleccionados = userList.filter(usuario => usuario.atqCode != 0);

            if (usuariosSeleccionados && usuariosSeleccionados.length > 0) {
                const idsSelect = usuariosSeleccionados.map((i) => {
                    return i.userID
                })

                setSelectedIds(idsSelect)
            }

            setProveedorSelect(usuariosSeleccionados);
        }
    }

    const closeAlert = (event) => {
        setAlert(false);
    }

    return (
        <div className='container'>
            <SubNavBarComponent title={'EVENTOS'} />
            <div className='tableContainer'>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'end', fontSize: '18px', fontFamily: 'Montserrat, sans-serif', color: '#094070',
                                fontWeight: '700' }}>
                        <button className='button' onClick={() => openDialogNewEvent("nuevo")}> <Icon color='white'>event_icon</Icon> CREAR EVENTO</button>
                </div>

                <div
                    className="ag-theme-quartz" // applying the grid theme
                    style={{ height: 700, marginTop: 20 }} // the grid will fill the size of the parent container
                >
                    <AgGridReact
                        ref={gridRef}
                        rowData={events}
                        columnDefs={tableColumns}
                        columnTypes={columnTypes}
                        defaultColDef={defaultColDef}
                        pagination={pagination}
                        paginationPageSize={paginationPageSize}
                        paginationPageSizeSelector={paginationPageSizeSelector}
                        rowHeight={rowHeight}
                        autoSizeStrategy={autoSizeStrategy}
                        alwaysShowHorizontalScroll={showScroll}
                        noRowsOverlayComponent={customNoEventsOverlay}
                        noRowsOverlayComponentParams={noRowsOverlayComponentParams}     
                    />
                </div>
            </div>



            <Dialog open={openNewEventDialog} onClose={handleCloseNewEventDialog} aria-labelledby='newEv-dialog-title' fullWidth={true} maxWidth='md'>
                <DialogTitle className='dialogTitleBg' id='newEv-dialog-title'>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        {dialogTitle}

                        <IconButton aria-label='Cerrar' onClick={handleCloseNewEventDialog}>
                            <CloseIcon style={{color: 'white'}} />
                        </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div style={{display: 'flex', gap: '20px', paddingTop: '20px', flexWrap: 'wrap'}}>
                        <TextField
                            id='nameEvent'
                            label="Nombre del evento"
                            type='text'
                            value={newEvent.nameEvent}
                            variant='outlined'
                            style={{ width: '50%'}}
                            onChange={(e) => onInputChange(e, "nameEvent")}
                            error={validation && !newEvent.nameEvent}
                        />

                        <TextField
                            id='startDate'
                            label="Inicio del evento"
                            type='date'
                            variant='outlined'
                            value={newEvent.startDate}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => onInputChange(e, "startDate")}
                            error={validation && !newEvent.startDate}
                        />

                        <TextField
                            id='endDate'
                            label="Fin del evento"
                            type='date'
                            variant='outlined'
                            value={newEvent.endDate}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => onInputChange(e, "endDate")}
                            error={validation && !newEvent.endDate}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className='button' onClick={createEvent}>{dialogButtonTxt}</button>
                </DialogActions>
            </Dialog>

            {/* DELETE EVENT DIALOG */}
            <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog} aria-labelledby='delete-event-dialog-title' fullWidth={true} maxWidth="sm">
                <DialogContent>
                    <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                        <Icon color='secondary' fontSize='large'>warning_icon</Icon> <p>¿Esta seguro que desea eliminar el evento <strong>{newEvent.nameEvent}</strong>?</p>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button className='' onClick={handleCloseDeleteDialog}>No</Button>
                    <button className='button' onClick={deleteEvent}>Si</button>
                </DialogActions>
            </Dialog>

            {/* USUARIOS DIALOG */}
            <Dialog open={openProvDialog} onClose={handleCloseProvDialog} aria-labelledby='prov-dialog' fullWidth={true} maxWidth="sm">
                <DialogTitle className='dialogTitleBg' id='newEv-dialog-title'>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        USUARIOS
                        <IconButton aria-label='Cerrar' onClick={handleCloseProvDialog}>
                            <CloseIcon style={{color: 'white'}} />
                        </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <p>Seleccione los usuarios para su evento</p>
                    
                    <br/>
                    <List>
                        {catUsersEvent && catUsersEvent.length > 0 && catUsersEvent.sort((a, b) => b.atqCode - a.atqCode).map((option) => (
                            <ListItem key={option.userID} role={undefined} dense button onClick={() => { handleSelectUser(option)}}>
                                <ListItemIcon>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                        edge="start"
                                        checked={proveedorSelect.indexOf(option) !== -1}
                                        tabIndex={-1}
                                        disableRipple/>
                                    }  
                                /> {/*checked={proveedorSelect.includes(option)} */}        
                                </ListItemIcon>
                                <ListItemText 
                                    primary={`${option.firstName} ${option.firstLastName || ''} ${option.secondLastName || ''}`} 
                                    secondary={`${option.email}`} />
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
                <DialogActions>
                    <button className='button' onClick={() => {handleCloseProvDialog(), setAlert(true)}}>GUARDAR</button>
                </DialogActions>
            </Dialog>

            {/*<Snackbar open={showAlert} autoHideDuration={5000} onClose={closeAlert} anchorOrigin={{vertical: 'center', horizontal: 'right'}} >
                            <Alert severity='success'>{serviceMessage}</Alert>
                        </Snackbar> */}
            <Snackbar open={showAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{vertical: 'center', horizontal: 'center'}} >
                <Alert severity='success'>CAMBIOS GUARDADOS</Alert>
            </Snackbar>
        </div>
    )
}